// Side-effect import: registers the styled-components `DefaultTheme` augmentation so
// shared `config/themeV2` utilities that read `theme.colors` type-check correctly.
import "config/styledTheme";
import {lightContent} from "config/themeV2";
import styled, {createGlobalStyle} from "styled-components";

export const MainContainer = styled.div`
    height: 100vh;
    display: flex;
    flex-direction: column;
`;

export const GlobalStyle = createGlobalStyle`
    a, a:hover, a:visited {
        color: ${lightContent["action-primary"]};
    }
`;
